<template>
	<div>
    <el-button type="success" size="small" @click="exportData">导出数据</el-button>
  </div>
</template>

<script>
  import axios from 'axios'
  let FileSaver=require("../utils/FileSaver")
  import { getStationData,getWZHistoryData } from '@/api/api'
	export default {
		name: 'HeadTag',
		props: {
      profileInfo: Object,
      lineTStr: String,
      timeType: String
		},
    data () {
      return {
  
      }
    },
    methods:{
      exportData(){
        getWZHistoryData({uid: 1579, timepoint: this.lineTStr, maptype: this.timeType})
        // axios.get(`http://p.jngrid.novaecs.com/api/yc2/getWZHistoryData?uid=`+1579+`&timepoint=`+this.lineTStr + '&maptype='+this.timeType)
        .then(x=>{
          let wzData = x.data
          var content = [];
          content[0]=[`序号,设备号, 微站名称, PM₂.₅,PM₁₀,PM₂.₅局部污染程度系数, PM₁₀局部污染程度系数\n`]

          let params1 = {station_type:'wz',time:this.lineTStr,data_type:'pm25_pollution',time_type:this.timeType,city: this.profileInfo.city,group_id:this.profileInfo.group_id,profile_id:this.profileInfo.id}
          let params2 = {station_type:'wz',time:this.lineTStr,data_type:'pm10_pollution',time_type:this.timeType,city: this.profileInfo.city,group_id:this.profileInfo.group_id,profile_id:this.profileInfo.id}
          getStationData(params1).then(p=>{
            let vals1 = p.data.values
            getStationData(params2).then(p2=>{
              let vals2 = p2.data.values
              for(var i in wzData){
                let wz_d = wzData[i]
                let pollution_index_pm25 = this.$_.find(vals1, function(o){
                  return o[2] == wz_d.station_info.ID
                })
                let pollution_index_pm10 = this.$_.find(vals2, function(o){
                  return o[2] == wz_d.station_info.ID
                })
                if (!pollution_index_pm25 || !pollution_index_pm10){
                  continue
                }
                var text=`${parseInt(i)+1},="${wz_d.station_info.DevSN}",${wz_d.station_info.Name},${wz_d.pm25},${wz_d.pm10},${pollution_index_pm25[1]},${pollution_index_pm10[1]}\t\n`
                content.push([text])
              }
              var file_name = this.lineTStr + '_' + this.timeType
              var blob = new Blob(content, { type: "text/plain;charset=utf-8" });
              FileSaver.saveAs(blob, file_name + ".csv");
            })
          })
        })
      }
    }
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ExportData.vue